<!--
 * @Description: 附件位置场所分类
 * @Author: 琢磨先生
 * @Date: 2022-05-11 15:31:18
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2022-05-12 16:43:13
-->



<template>
  <el-drawer
    v-model="drawer"
    :title="title"
    direction="rtl"
    size="600px"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="140px">
      <el-form-item label="父级">
          <el-select v-model="form.father_id"  placeholder="请选择父级" clearable >
              <el-option v-for="item in types"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
          </el-select>
          
      </el-form-item>
      
      <el-form-item label="名称" prop="name">
        <el-col :span="14">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="停用" prop="is_stop">
        <el-switch v-model="form.is_stop"> </el-switch>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
          :disabled="loading"
          :loading="loading"
          >确定</el-button
        >
        <el-button @click="cancelClick" :disabled="loading">取消</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      drawer: false,
      title: "编辑分类",
      form: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ], 
      },
    };
  },
  props: ["item", "types", "reload"],
  watch: {
    item: {
      handler() {
        if (this.item) {
          this.drawer = true;
          this.form = Object.assign({},this.item);
        }
      },
    },
  },

  methods: {
    /**
     * 提交保存
     */
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .post("/admin/v1/location/type/edit", this.form)
            .then((res) => {
              this.loading = false;
              if (res.code == 0) {
                this.drawer = false;
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                if (this.reload) {
                  this.reload();
                }
              }
            })
            .cath(() => {
              this.loading = false;
            });
        }
      });
    },
    /**
     * 取消
     */
    cancelClick() {
      this.drawer = false;
      if (this.reload) {
        this.reload();
      }
    },
    
  },
};
</script>